<template>
  <v-expansion-panel>
    <v-dialog v-model="isActiveAddressModal" width="800" hide-overlay>
      <v-card>
        <Addresses
          @selectedCep="selectedCep($event)"
          @close="isActiveAddressModal = $event"
        ></Addresses>
      </v-card>
    </v-dialog>
    <v-expansion-panel-header color="#007BC3">
      <template v-slot:actions>
        <v-icon color="white" class="font-weight-black"> icon-up-arrow </v-icon>
      </template>
      <b class="white--text">ENDEREÇO</b>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="mt-6">
      <v-row>
        <v-col cols="3">
          <BaseInputValidation
            v-mask="'#####-###'"
            :loading="isAddressSearch"
            id="zip_code"
            name="CEP *"
            rules="required"
            v-model="form.addresses.zip_code_formatted"
            icon="mdi-magnify"
            @handleUp="handlerSearch"
            @handlerAppendClick="handlerSearch"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="4">
          <BaseInputValidation
            id="state"
            name="UF *"
            rules="required"
            maxlength="2"
            v-model="form.addresses.state"
            :loading="isAddressSearch"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="5">
          <BaseInputValidation
            :loading="isAddressSearch"
            id="city"
            name="Cidade *"
            rules="required"
            v-model="form.addresses.city"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="4">
          <BaseInputValidation
            :loading="isAddressSearch"
            id="neighborhood"
            name="Bairro *"
            rules="required|max:80"
            v-model="form.addresses.neighborhood"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="6">
          <BaseInputValidation
            :loading="isAddressSearch"
            id="street"
            name="Rua *"
            rules="required|max:100"
            v-model="form.addresses.street"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="2">
          <BaseInputValidation
            id="number"
            name="Número *"
            rules="required|max:8"
            v-model="form.address_number"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="6">
          <BaseInputValidation
            id="complement"
            name="Complemento"
            rules="max:60"
            v-model="form.address_complement"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
        <v-col cols="5">
          <BaseInputValidation
            v-mask="['(##) ####-####', '(##) #####-####']"
            id="phone"
            name="Telefone *"
            rules="required"
            v-model="form.phone_formatted"
            :disabled="view"
          ></BaseInputValidation>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import BaseInputValidation from "../../../../components/UI/BaseInputValidation";
import Addresses from "../../../addresses";
import { mask } from "vue-the-mask";
import { mapGetters, mapActions } from "vuex";
// import cloneDeep from "lodash/cloneDeep";
import _ from "lodash";
export default {
  props: { view: { type: Boolean, default: false } },
  directives: { mask },
  filters: {},
  data: () => ({
    isAddressSearch: false,
    isActiveAddressModal: false,
    form: {
      phone: "",
      phone_formatted: "",
      address_complement: "",
      address_number: "",
      addresses: {
        street: "",
        neighborhood: "",
        city: "",
        state: "",
        zip_code: "",
        zip_code_formatted: "",
        codmunicipio: ""
      }
    }
  }),
  components: {
    BaseInputValidation,
    Addresses
  },

  computed: {
    ...mapGetters({
      addressOnViacep: "$_address/addressOnViacep",
      provider: "$_provider/provider"
    })
  },
  methods: {
    async handlerSearch(e) {
      if (e.pointerId) this.isActiveAddressModal = true;
      else if (
        _.hasIn(this.form, "addresses.zip_code_formatted") &&
        this.form.addresses.zip_code_formatted.length === 9
      ) {
        this.isAddressSearch = true;
        await this.searchZipCode(
          this.form.addresses.zip_code_formatted.replace(/[^0-9]/g, "")
        );
        this.setAddressFields();
        this.isAddressSearch = false;
      }
    },
    ...mapActions({
      searchZipCode: "$_address/showAddressOnViaCep"
    }),

    setAddressFields() {
      this.form.addresses.neighborhood = this.addressOnViacep.bairro;
      this.form.addresses.street = this.addressOnViacep.logradouro;
      this.form.addresses.city = this.addressOnViacep.localidade;
      this.form.addresses.state = this.addressOnViacep.uf;
      this.form.addresses.codmunicipio = this.addressOnViacep.codmunicipio;
    },

    selectedCep(address) {
      this.form.addresses = {
        zip_code_formatted: address.cep,
        neighborhood: address.bairro,
        city: address.localidade,
        state: address.uf,
        street: address.logradouro,
        codmunicipio: address.codmunicipio
      };
    }
  },
  created() {
    Object.entries(this.form).forEach(element => {
      this.form[element[0]] = this.provider[element[0]];
    });
    if (_.hasIn(this.form, "addresses.zip_code"))
      this.form.addresses.zip_code_formatted = this.form.addresses.zip_code;
    if (_.hasIn(this.form, "phone"))
      this.form.phone_formatted = this.form.phone;
  },
  watch: {
    form: {
      handler: function(newVal) {
        newVal.phone = newVal.phone_formatted.replace(/[^0-9]/g, "");
        newVal.addresses.zip_code = newVal.addresses.zip_code_formatted.replace(
          /[^0-9]/g,
          ""
        );
        this.$emit("setFields", {
          data: newVal
        });
      },
      deep: true
    }
  }
};
</script>

<style></style>
